import React, { ReactNode, useEffect } from "react";

import { Button } from "@components/buttons";
import { Modal } from "@lib/modal";
import useFixBody from "@state/hooks/shared/useFixBody";

import { getMaxViewAxis } from "../config/LiveStreamConfig";

export function LiveStreamFullScreenOverlay(props: {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
}) {
	const { open, onClose, children } = props;

	useFixBody(true, open);

	useEffect(() => {
		if (!open) return;
		const onKeyDown = (e: KeyboardEvent) => {
			if (e.key === "Escape") {
				onClose();
			}
		};
		document.addEventListener("keydown", onKeyDown);
		return () => document.removeEventListener("keydown", onKeyDown);
	}, [open, onClose]);

	if (!open) {
		return <>{children}</>;
	}

	return (
		<Modal>
			<div
				className="popup--player popup--player--full"
				// Backdrop click does NOT close
			>
				<Button
					type="button"
					onClick={onClose}
					className="btn--square btn--square--med btn--ghost popup--player--full__close"
					iconOnly
					iconClassName="u-icon--tny u-icon--close u-color--core--snow"
					aria-label="Close"
				/>

				<div
					className="popup--player--full__stream"
					style={{
						maxWidth: getMaxViewAxis(),
						maxHeight: getMaxViewAxis(),
					}}
				>
					{children}
				</div>
			</div>
		</Modal>
	);
}
